import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Sire name is required!"),
  passportNumber: Yup.string().required("Passport Number is required!"),
});
